<div class="wrapper">
	<div class="heading">
		<div class="back-button">
			<img (click)="back()" [src]="'./assets/Back Button (Gray-White).svg'" alt="Back Button (Blue-White).svg" />
		</div>
		<div class="ds-dialog-title-white ds-flex-center-center">
			<span>Check In</span>
		</div>
	</div>
	<div class="content">
		<ng-container *ngIf="selectedActivity; else page1">
			<ng-container *ngTemplateOutlet="page2"></ng-container>
		</ng-container>
	</div>
</div>

<!-- Page 1-->
<ng-template #page1>
	<ng-container *ngIf="!loading && availableActivities.length > 0; else empty">
		<div class="content-heading">Select Your Activity</div>
		<div class="activities">
			<ng-container *ngFor="let available of availableActivities">
				<div class="activity-box" (click)="selectActivity($event, available)">
					<div class="activity-title">{{ available.activity.name }}</div>
					<div class="activity-teacher">{{ available.activity.teacher_name }}</div>
				</div>
			</ng-container>
		</div>
	</ng-container>
	<ng-template #empty>
		<div class="content-heading">No activities at this time</div>
		<div class="no-activities">There are no activities to check into right now. You can start checking in 5 minutes before the activity starts.</div>
	</ng-template>
</ng-template>

<!-- Page 2-->

<ng-template #page2>
	<div class="page2">
		<div class="activity-title">{{ selectedActivity!.activity.name }}</div>
		<div class="activity-teacher">{{ selectedActivity!.activity.teacher_name }}</div>
		<sp-student-typer
			class="typer"
			[enableIdSearch]="true"
			[enableScanning]="true"
			[enableStudentSearch]="true"
			[tintColor]="'#7083A0'"
			(onSelectStudent)="checkInStudent($event, selectedActivity!.instance, selectedActivity!.activity)">
		</sp-student-typer>
	</div>
</ng-template>
